export default __webpack_public_path__ + "static/media/thumbnail.54f4e487.webp";